import { types } from './types'

export const mutations = {
  [types.SET_PRODUCTS] (state, products = []) {
    state.products = products
  },
  [types.SET_AGGREGATIONS] (state, aggregations = []) {
    state.aggregations = aggregations
  },
  [types.SET_PRODUCTS_SORT] (state, productSort) {
    state.productSort = productSort
  },
  [types.SET_CATEGORY] (state, category = []) {
    state.category = category
  },
  [types.SET_ARTICLES] (state, articles = []) {
    state.articles = articles
  },
  [types.UPDATE_FILTERS] (state, filters = {}) {
    state.filters = {
      ...state.filters,
      ...filters,
    }
  },
  [types.SET_PER_PAGE] (state, payload = 10) {
    let perPage = +payload

    perPage = isNaN(perPage) ? 10 : perPage
    perPage = perPage > 30 ? 30 : perPage
    perPage = perPage < 10 ? 10 : perPage

    state.perPage = perPage
  },
  [types.IS_PENDING] (state, isPending) {
    state.isPending = isPending
  },
  [types.SET_PRODUCT_TOTAL_COUNT] (state, productsTotalCount) {
    state.productsTotalCount = productsTotalCount
  },
  [types.SET_PRODUCT_TOTAL_PAGES] (state, productsTotalPages) {
    state.productsTotalPages = productsTotalPages
  },
  [types.SET_QUERY] (state, query) {
    state.query = query
  },
  [types.SET_CLICKED_FROM_HEADER_SEARCH] (state, isClickedFromHeaderSearch) {
    state.isClickedFromHeaderSearch = isClickedFromHeaderSearch
  },
}
